import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { ContactMergeData } from './contact.merge.data';

@MergeSchema({
    entity: ActivityEntityName.Item,
    displayName: "Financial Item",
    name: "FinancialItemLineMergeDataSchema"
})
export class FinancialItemLineMergeData {

    @MergeField()
    name: string;

    @MergeField()
    description: string;

    @MergeField()
    longDescription?: string;

    @MergeField()
    location?: string;

    @MergeField()
    note?: string;

    @MergeField()
    codeUoM: string;

    @MergeField()
    quantity: string;

    @MergeField()
    buyPrice?: string;

    @MergeField()
    sellPrice?: string;

    @MergeField()
    adjustment?: string;

    @MergeField()
    adjustmentType?: string;

    @MergeField()
    totalBuy?: string;

    @MergeField()
    totalSellEx?: string;

    @MergeField()
    totalSellInc?: string;

    @MergeField()
    totalAdjustment?: string;

    @MergeField()
    totalTax?: string;

    @MergeField()
    saleTaxRate?: string;

    @MergeField()
    saleGLCode?: string;
}

export const FinancialItemLineMergeDataSchema = getSchema(FinancialItemLineMergeData);